/**
 * Include your custom JavaScript here.
 */

/* === MHH — reveal-on-scroll para cartões de produto (à prova de falhas) === */
(function () {
  function init() {
    if (!('IntersectionObserver' in window)) return; // sem suporte: deixa visível
    var vh = window.innerHeight || 800;
    var items = Array.prototype.slice.call(document.querySelectorAll('.product-item'));
    var toObserve = [];

    items.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.9) return; // já visível: não esconder
      el.style.opacity = '0';
      el.style.transition = 'opacity .6s cubic-bezier(.2,.7,.2,1)';
      el.style.willChange = 'opacity';
      toObserve.push(el);
    });

    if (!toObserve.length) return;

    function reveal(el) { el.style.opacity = '1'; }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -5% 0px' });

    toObserve.forEach(function (el) { io.observe(el); });

    // failsafe: nunca deixar nada escondido
    setTimeout(function () { toObserve.forEach(reveal); }, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* === MHH #AN-3 — barra sticky "adicionar ao carrinho" === */
(function () {
  function initATC() {
    var bar = document.getElementById('mhh-atc');
    if (!bar) return;
    var form = document.querySelector('form[action*="/cart/add"]');
    var btn = document.getElementById('mhh-atc-btn');
    if (btn && form) {
      btn.addEventListener('click', function () {
        var real = form.querySelector('[type="submit"], button:not([type="button"])');
        if (real) { real.click(); }
        else if (form.requestSubmit) { form.requestSubmit(); }
        else { form.submit(); }
      });
    }
    if (form && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { bar.classList.toggle('is-visible', !e.isIntersecting); });
      }, { threshold: 0 });
      io.observe(form);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initATC);
  } else {
    initATC();
  }
})();

/* === MHH — extras de confiança na página de produto (sob o botão de compra) === */
(function () {
  function initPDP() {
    var tpl = document.getElementById('mhh-pdp-tpl');
    if (!tpl || !tpl.content) return;
    if (document.querySelector('.mhh-pdp')) return;
    var anchor = document.querySelector('.product-form__payment-container');
    if (!anchor) return;
    anchor.parentNode.insertBefore(tpl.content.cloneNode(true), anchor.nextSibling);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPDP);
  } else {
    initPDP();
  }
})();